var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import axios from "axios";
const defaultConfig = {
  baseURL: "",
  method: "get",
  timeout: 1e3 * 10,
  withCredentials: false
};
const defaultCustomConfig = {
  raw: false,
  errorHandle: () => {
  },
  handleRequest: void 0,
  debugger: false
};
class HttpServer {
  constructor(options, customOptions) {
    __publicField(this, "instance");
    __publicField(this, "debugger");
    const config = Object.assign(defaultConfig, options);
    const customConfig = Object.assign(defaultCustomConfig, customOptions);
    this.instance = axios.create(config);
    this.debugger = customOptions == null ? void 0 : customOptions.debugger;
    if (customConfig.handleRequest) {
      this.handleRequest(customConfig.handleRequest);
    }
    if (!customConfig.raw && customConfig.errorHandle) {
      this.handleResponse(customConfig.errorHandle);
    }
  }
  handleRequest(handle) {
    this.instance.interceptors.request.use((config) => {
      if (this.debugger) {
        console.log("\u8BF7\u6C42 config \u6253\u5370", config);
      }
      return handle(config);
    }, (error) => {
      return Promise.reject(error);
    });
  }
  handleResponse(errorHandle) {
    this.instance.interceptors.response.use((response) => {
      if (this.debugger) {
        console.log("\u8BF7\u6C42 response \u6253\u5370", response);
      }
      if (response.request.responseType === "blob")
        return response.data;
      const data = response.data;
      const code = data.code || data.statusCode;
      if (code === 200)
        return data;
      errorHandle(data, response);
      return Promise.reject(data);
    }, (error) => {
      const response = {
        code: +error.message.slice(-3),
        data: {},
        msg: error.message,
        total: 0,
        trace: ""
      };
      errorHandle(response);
      return Promise.reject(response);
    });
  }
  async get(url, params, config) {
    return await this.instance.get(url, __spreadProps(__spreadValues({}, config), {
      params
    }));
  }
  async delete(url, params, config) {
    return await this.instance.delete(url, __spreadProps(__spreadValues({}, config), {
      params
    }));
  }
  async post(url, data, config) {
    return await this.instance.post(url, data, config);
  }
  async put(url, data, config) {
    return await this.instance.put(url, data, config);
  }
}
export { HttpServer as default };
